export default "__VITE_ASSET__DQfFXkUz__"